import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}></th>
<th parentName="tr" {...{
            "align": null
          }}></th>
<th parentName="tr" {...{
            "align": null
          }}></th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Field Name`}</strong></td>
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Details`}</strong></td>
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Example`}</strong></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger"><a parentName="td" {...{
                "href": "#role-id"
              }}>{`Role ID`}</a>{` - Mandatory`}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Unique ID of the Role to be allocated to the Employee.`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`8049e35984f04812b42cb109ae7a58a3`}</td>
</tr>
</tbody>
</table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      